import { Link } from "react-router-dom";
import { TrendingUp, Mail, Phone } from "lucide-react";

export const Footer = () => (
  <footer id="iletisim" data-testid="site-footer" className="bg-navy-950 text-white relative grain overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3 relative z-10">
      <div>
        <div className="flex items-center gap-3">
          <span className="grid place-items-center h-11 w-11 rounded-xl bg-gradient-to-br from-brand-400 to-brand-600">
            <TrendingUp className="h-6 w-6 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-display leading-none">
            <span className="block font-extrabold tracking-tight text-lg">TÜRKİYE</span>
            <span className="block text-brand-400 font-extrabold tracking-[0.25em] text-xs">BORSASI</span>
          </span>
        </div>
        <p className="mt-5 text-sm text-white/55 max-w-xs leading-relaxed">
          Güçlü geçmişi, dinamik bugünü ve yükselen potansiyeliyle Türkiye Borsası.
        </p>
      </div>

      <div>
        <h4 className="font-display font-bold text-sm tracking-widest text-white/40 uppercase">İletişim</h4>
        <ul className="mt-5 space-y-3 text-sm text-white/70">
          <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-brand-400" /> info@trhisseborsalari.com</li>
          <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-brand-400" /> +90 539 118 01 30</li>
        </ul>
      </div>

      <div>
        <h4 className="font-display font-bold text-sm tracking-widest text-white/40 uppercase">Yasal</h4>
        <ul className="mt-5 space-y-3 text-sm">
          <li>
            <Link data-testid="footer-privacy-link" to="/gizlilik-politikasi" className="text-white/70 hover:text-brand-400 transition-colors">
              Gizlilik Politikası
            </Link>
          </li>
          <li>
            <Link data-testid="footer-agreement-link" to="/kullanici-sozlesmesi" className="text-white/70 hover:text-brand-400 transition-colors">
              Kullanıcı Sözleşmesi
            </Link>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10 relative z-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
        <p>© {new Date().getFullYear()} Türkiye Borsası. Tüm hakları saklıdır.</p>
        <div className="flex gap-6">
          <Link to="/gizlilik-politikasi" className="hover:text-white/70 transition-colors">Gizlilik Politikası</Link>
          <Link to="/kullanici-sozlesmesi" className="hover:text-white/70 transition-colors">Kullanıcı Sözleşmesi</Link>
        </div>
      </div>
    </div>
  </footer>
);
